import React, { useState, useEffect } from "react";
import Header from "../Components/ApplicationReport/Header";
import ApplicationOverview from "../Components/ApplicationReport/ApplicationOverview";
import { getApplicationReport } from "../actions/ApplicationReportAction";
import { getApplicationReports } from "../services/applicationReport";
import { getSalesReportsWithQueries } from "../services/salesReportService";
import { getDistributorNames } from "../Common/functions";

const ApplicationReport = ({ userRole }) => {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [filters, setFilters] = useState({});
  const [loading, setLoading] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const getTotalPages = (totalItems, itemsPerPage) => {
    return itemsPerPage > 0 ? Math.ceil(totalItems / itemsPerPage) : 0;
  };

  const getApplicationReport1 = async () => {
    setLoading(true);
    setData([]);

    let distributorName;
        
    if (userRole === "super_admin") {
      distributorName = filters.distributorName;
    } else if (userRole === "manager") {
      distributorName =
        !filters.distributorName || filters.distributorName.trim() === ""
          ? getDistributorNames()
          : filters.distributorName;
    } else {
      distributorName = getDistributorNames();
    }

    try {
      const payload = {
        category: "sales tracking",
        tracking_status: filters.trackingStatus,
        page_size: itemsPerPage,
        page_number: currentPage,
        start_date: filters.fromDate,
        end_date: filters.toDate,
        distributor_name:distributorName,
        doctorsname: filters.doctorName,
        group_title: filters.chooseTeam,
        search_term: searchTerm,
      }
      // Remove null, undefined, and empty string values
      const cleanedPayload = Object.fromEntries(
        Object.entries(payload).filter(([key, value]) => {
          return value !== null && 
                value !== undefined && 
                value !== "" && 
                value !== " ".trim(); // Also removes whitespace-only strings
        })
      );
      const result = await getSalesReportsWithQueries(cleanedPayload);

      if (result?.data) {
        setData(result.data.items);
        setCurrentPage(result.data.current_page);
        setTotalCount(result.data.total_records);
        setTotalPages(getTotalPages(result.data.total_records, itemsPerPage));
      } else {
        console.error("Invalid result format:", result);
      }
    } catch (error) {
      console.error("Error fetching sales reports:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (currentPage !== 1) {
      setCurrentPage(1);
    } else {
      getApplicationReport1();
    }
  }, [searchTerm]);

  useEffect(() => {
    getApplicationReport1();
  }, [itemsPerPage, currentPage, filters]);

  return (
    <div>
      <Header userRole={userRole} />
      <div className="mt-6">
        <ApplicationOverview
          data={data}
          loading={loading}
          currentPage={currentPage}
          totalPages={totalPages}
          totalCount={totalCount}
          setCurrentPage={setCurrentPage}
          userRole={userRole}
          setSearchTerm={setSearchTerm}
          setFilters={setFilters}
          setItemsPerPage={setItemsPerPage}
          itemsPerPage={itemsPerPage}
        />
      </div>
    </div>
  );
};

export default ApplicationReport;
